import React, { memo, useCallback } from "react";
import { Icon, Tooltip, ClipboardCopy } from "@patternfly/react-core";
import CheckCircleIcon from "@patternfly/react-icons/dist/esm/icons/check-circle-icon";
import ExclamationCircleIcon from "@patternfly/react-icons/dist/esm/icons/exclamation-circle-icon";

const PodsTable = memo(({ pods, loading, error, onRefetch, formatBytes }) => {
  const getStatusColor = useCallback((status) => {
    switch (status) {
      case "Running":
        return "success";
      case "Pending":
        return "warning";
      case "Failed":
        return "danger";
      case "CrashLoopBackOff":
        return "danger";
      default:
        return "grey";
    }
  }, []);

//   if (loading) return <span>Ładowanie...</span>;
  if (loading) return <span></span>;

  if (error)
    return <div style={{ color: "red" }}>Błąd pobierania pods!</div>;

  if (!pods?.length) return null;

  return (
    <table className="table">
      <tbody>
        <tr>
          {/* <th>Name</th> */}
          <th>Node name</th>
          <th>Node IP</th>
          <th>CPU</th>
          <th>RAM</th>
          <th>Status</th>
          <th>Ready</th>
          {/* <th>Restarts</th> */}
        </tr>

        {pods.map((pod) => (
          <tr key={pod.name}>
            {/* <td>{pod.name}</td> */}
            <td>{pod.node_name}</td>
            <td>
                <ClipboardCopy
                    variant="inline-compact"
                    hoverTip="Kopiuj"
                    clickTip="Skopiowano"
                >
                    {pod.host_ip}
                </ClipboardCopy>
            </td>
            <td>{pod.cpu_cores_utilization}</td>
            <td>{formatBytes(pod.memory_bytes.toFixed(1))}</td>

            <td>
              <Tooltip content={`Status: ${pod.status}`}>
                <Icon status={getStatusColor(pod.status)}>
                  {pod.status ? (
                    <CheckCircleIcon />
                  ) : (
                    <ExclamationCircleIcon />
                  )}
                </Icon>
              </Tooltip>
            </td>
            <td>
              <Icon status={pod.ready ? "success" : "warning"}>
                {pod.ready ? (
                  <CheckCircleIcon />
                ) : (
                  <ExclamationCircleIcon />
                )}
              </Icon>
            </td>
            {/* <td>{pod.restarts}</td> */}
          </tr>
        ))}
      </tbody>
    </table>
  );
});

export default PodsTable;